export default __webpack_public_path__ + "ec3e10aff03df31a79df391a3e0192ba.jpg";